module.exports = __webpack_public_path__ + "img/encite-coursebb.083fa4ad.png";